import { get } from "./util";

export async function getPing() {
  return get({
    query: "Misc/ping",
  });
}
